import { SocketType } from '../types/socket';

export interface InactivityMessageStatusSocketMessage {
  socket: SocketType.INACTIVITY_MESSAGE_STATUS;
  sessionId: string;
  content: string;
  timestamp: Date;
}

export const buildInactivityMessageStatusContent = (enabled: boolean): string =>
  JSON.stringify({ enabled });

export const buildInactivityMessageStatusSocketMessage = (
  sessionId: string,
  enabled: boolean,
  timestamp: Date
): InactivityMessageStatusSocketMessage => ({
  socket: SocketType.INACTIVITY_MESSAGE_STATUS,
  sessionId,
  content: buildInactivityMessageStatusContent(enabled),
  timestamp
});
